import { hasAnyRole } from '../../../lib/roleUtils';

// Debounce utility function
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// Check if session user has system-admin role (Gadget-level "admin" IS system-admin)
export const isSystemAdmin = (session) => {
  return hasAnyRole(session?.user?.roles, ['admin', 'system-admin']);
};

// Helper function to safely convert instructor fields to arrays
export const safeArrayConversion = (field) => {
  if (typeof field === 'number' || (typeof field === 'string' && /^\d+$/.test(field))) {
    return [];
  }

  if (!field) {
    return [];
  }

  if (Array.isArray(field)) {
    return field;
  }

  if (typeof field === 'string') {
    if (field.trim() === '' || field.trim() === 'null' || field.trim() === 'undefined') {
      return [];
    }
    try {
      const parsed = JSON.parse(field);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  if (typeof field === 'object' && field !== null) {
    if (field.length !== undefined && typeof field.length === 'number') {
      try {
        const converted = Array.from(field);
        return Array.isArray(converted) ? converted : [];
      } catch (error) {
        return [];
      }
    }

    const possibleArrayKeys = Object.keys(field);
    if (possibleArrayKeys.length === 0) {
      return [];
    }
  }

  return [];
};

// Helper function to safely map over arrays, with fallback for corrupted data
export const safeArrayMap = (arrayLike, mapFn, fallback = []) => {
  try {
    const safeArray = safeArrayConversion(arrayLike);

    if (!Array.isArray(safeArray)) {
      return fallback;
    }

    return safeArray.map(mapFn);
  } catch (error) {
    console.error('safeArrayMap error:', error, { arrayLike, fallback });
    return fallback;
  }
};
